var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenshot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 254,
    height: 145,
    viewBox: "0 0 254 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-screenshot_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 145
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screenshot_2",
    clipPath: "url(#clip-screenshot_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849",
    transform: "translate(14649.391 -12994.113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24881",
    "data-name": "Rectangle 24881",
    width: 254,
    height: 145,
    transform: "translate(-14649.391 12994.113)",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "picture",
    transform: "translate(-14549.81 12963.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8903",
    "data-name": "Group 8903",
    transform: "translate(0 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8902",
    "data-name": "Group 8902",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18730",
    "data-name": "Path 18730",
    d: "M53.733,61H1.622A1.606,1.606,0,0,0,0,62.622v37.3l21.19-14.6,12.974,16.217,6.487-6.487,14.25,7.655a1.864,1.864,0,0,0,.454-1.168V62.622A1.606,1.606,0,0,0,53.733,61Z",
    transform: "translate(0 -61)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8905",
    "data-name": "Group 8905",
    transform: "translate(0 70.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8904",
    "data-name": "Group 8904",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18731",
    "data-name": "Path 18731",
    d: "M37.408,160.73a4.865,4.865,0,1,0-4.865-4.865A4.871,4.871,0,0,0,37.408,160.73Zm4.39,9.255a1.622,1.622,0,0,0-2.293,0l-5.34,5.34-11.842-14.8a1.622,1.622,0,0,0-2.413-.134L0,180.191v1.622a1.606,1.606,0,0,0,1.622,1.622H53.733a1.865,1.865,0,0,0,1.168-.454Z",
    transform: "translate(0 -151)",
    fill: "#c2cce1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot2);
export default __webpack_public_path__ + "static/media/screenshot_2.981ad94a1038c2f208d5ff9464e413a3.svg";
export { ForwardRef as ReactComponent };